
export function allAnswer(){
    const defineArray : string[][] = [
        ['李','王','张','刘','陈','杨','赵','黄','周','吴','徐','孙','胡','朱','高','林'],
        ['何','郭','马','罗','梁','宋','郑','谢','韩','唐','冯','于','董','萧','程','曹'],
        ['袁','邓','许','傅','沈','曾','彭','吕','苏','卢','蒋','蔡','贾','丁','魏','薛'],
        ['叶','阎','余','潘','杜','戴','夏','钟','汪','田','任','姜','范','方','石','姚'],
        ['谭','廖','邹','熊','金','陆','郝','孔','白','崔','康','毛','邱','秦','江','史'],
        ['顾','侯','邵','孟','龙','万','段','甄','钱','汤','尹','黎','易','常','武','乔'],
        ['贺','赖','龚','文','庞','柳','兰','殷','施','陶','洪','翟','安','颜','倪','严'],
        ['牛','温','芦','季','俞','章','鲁','葛','伍','韦','申','尤','毕','聂','焦','向']
    ];
    return defineArray;
}

/**
 * 成功名称配置
 */
export function successName(){
    const defineArray : string[] = [
        "富贵","大炮","二狗","月京","建仁","寿生","庞光","翠花","旺财","铁柱",
        "麻子","大牛","春花","秋月","二毛","美丽","二丫","狗剩","土豆","解放",
        "荷花","素芬","百万"
    ];
    return defineArray;
}

/**
 * 获取随机成功姓名
 */
export function getRandomSuccessName(){
    let dataList : string[] = successName();
    let randomIndex : number = Math.trunc( Math.random() * dataList.length );
    return dataList[randomIndex];
}

/**
 *
 * @param row
 * @param col
 */
export default function getAnswerByPos( row : number , col : number ) : string{
    return allAnswer()[row-1][col-1];
}

/**
 *
 * @param value
 */
export function getAnswerItemByWeight( value : number ) : string{
    let dataList : string[][] = allAnswer();

    let rowLength : number = dataList[0].length;
    let rowNum : number = Math.trunc(value / rowLength ) == value /rowLength ? Math.trunc(value / rowLength ) - 1 : Math.trunc(value / rowLength );
    let colNum : number = value % rowLength == 0 ? 15 : (value % rowLength - 1);

    // for ( let itemArray of dataList ) {
    //     let findValue = itemArray.find(( item , index, list)=>{
    //         return item == value;
    //     });
    //     if ( findValue != null ) {
    //       return findValue;
    //     }
    // }

    return dataList[rowNum][colNum];
}
